import { get } from '@/axios'
import { INovelDetail } from '../novel'

export interface ISearchNovelRequest {
  keyword: string
  page?: number
  size?: number
}

export interface ISearchNovelResponse {
  count: number
  list: INovelDetail[]
}

export const searchNovel = async (params: ISearchNovelRequest, signal?: AbortSignal) => {
  const response = await get<ISearchNovelResponse>('/v2/search/novel', params, {}, { signal: signal })

  return response
}
